import { render, staticRenderFns } from "./FormulateInteger.vue?vue&type=template&id=66185a87"
import script from "./FormulateInteger.vue?vue&type=script&lang=js"
export * from "./FormulateInteger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports